"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.b2bActionRequiredNotification = void 0;
const helpers_1 = require("../../helpers");
const orders_1 = require("../orders");
const sendEmail_1 = require("../sendEmail");
const b2bActionRequiredNotification = async (supabase, order_id, variant_id) => {
    const order = await (0, orders_1.getOrderById)(supabase, order_id);
    const created_by = order.created_by_user;
    const variant = order?.variants
        ? order?.variants.find((v) => v.id === variant_id)
        : null;
    if (!variant)
        return null;
    const order_lines = (0, orders_1.variantGetActionRequiredLines)(variant);
    const email_obj = {
        language_code: "en",
        data: {
            agent: {
                logo: "https://golfsavers.b-cdn.net/assets/images/golfb2b_email_logo.jpg",
            },
            created_by: created_by?.first_name + " " + created_by?.last_name,
            agent_name: order?.agent?.name,
            order_id: order_id,
            variant_id: variant_id,
        },
        template_id: helpers_1.GOLFB2B_ACTION_REQUIRED_NOTIFICATION,
    };
    await (0, sendEmail_1.sendEmail)(email_obj);
    if (order_lines && order_lines.length > 0) {
        let message = ``;
        if (order_lines?.length > 1) {
            message = `The following items require action in variant ${variant?.name}: ${order_lines
                .map((line) => (0, orders_1.getOrderLineSimpleTitle)(line))
                .join(", ")}`;
        }
        else {
            message = `The following item requires action in variant ${variant?.name}: ${order_lines
                .map((line) => (0, orders_1.getOrderLineSimpleTitle)(line))
                .join(", ")}`;
        }
        // create a new order note.
        const note = {
            note: message,
            order_id: order_id,
            pinned: true,
            created_by: order.client?.id,
            type: "RATE_REQUEST",
        };
        await (0, orders_1.addOrderNote)(supabase, note);
    }
    return null;
};
exports.b2bActionRequiredNotification = b2bActionRequiredNotification;
